module.exports = __webpack_public_path__ + "img/background.e477651e.svg";